export enum ObjectPosition {
  InfoCard = "Info card",
  Overview = "Overview",
  StickyCTA = "Sticky CTA",
  NonStickyCTA = "Non-sticky CTA",
  CallMeBack = "Call Me Back",
}
